import PropTypes from 'prop-types';
import React from 'react';
import Button from '../components/Button';

const RetryButton = props => <Button {...props} text="Retry" ariaLabel="Retry" />;

RetryButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

RetryButton.defaultProps = {
    className: 'modal-btn',
};

export default RetryButton;
